export class UserGroup {
    groupName: string;
    groupDescription: string;
    groupEmail: string;
    admin: boolean;
    insertDate?: number;
    modifyDate?: number;
}